import * as React from "react"
import { Form } from "antd"
import PropTypes from "prop-types"
import Modal, { ModalFooter } from "components/Modal/Modal"
import "./ModalForm.scss"

const ModalForm = ({
  modalProps = {
    okText: "Save",
    confirmLoading: false,
  },
  formProps,
  children,
}) => {
  let classNames = ["modal-form"]
  if (modalProps?.className) {
    classNames.push(modalProps.className)
  }

  return (
    <Modal
      {...modalProps}
      className={classNames.join(" ")}
      footer={null}
    >
      <Form {...formProps}>
        {children}
        <Form.Item noStyle>
          <div className="ant-modal-footer">
            <ModalFooter
              onOkText={() => modalProps?.okText || "Save"}
              onOk={modalProps?.onFinish}
              onCancel={modalProps?.onCancel}
              disabled={modalProps?.disabled}
              htmlType="submit"
              confirmLoading={modalProps?.confirmLoading}
            />
          </div>
        </Form.Item>
      </Form>
    </Modal>
  )
}

ModalForm.propTypes = {
  modalProps: PropTypes.shape({
    className: PropTypes.string,
    okText: PropTypes.string,
    onFinish: PropTypes.func,
    onCancel: PropTypes.func,
    disabled: PropTypes.bool,
    confirmLoading: PropTypes.bool,
  }),
  formProps: PropTypes.object,
  children: PropTypes.node,
}

export default ModalForm
